<template>
  <el-popover popper-class="fotoo-el-popover"
          placement="bottom-end"
          width="325"
              trigger="hover">
    <div slot="reference" class="header-img reference">
      <img :src="userinfo.avatar" class="fotoo-el-popover-avatar"/>
      <div class="vip-icon" :class="'vip-icon-'+vipType">{{VERSIONS[vipType]?VERSIONS[vipType].versionName:''}}</div>
    </div>
    <div class="header-body">
      <el-row type="flex" justify="start" align="middle" style="height:80px;">
        <el-col :span="2"></el-col>
        <el-col :span="2">
          <div class="header-img">
            <img :src="userinfo.avatar" class="fotoo-el-popover-avatar"/>
            <div class="vip-icon" :class="'vip-icon-'+vipType"></div>
          </div>
        </el-col>
        <el-col :span="2"></el-col>
        <el-col>
          <div class="userName">
            {{userinfo.userName}}
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-between" align="middle"
              style="height:80px;background: linear-gradient(292deg,#ffe8d8 38%, #fffbf9 86%);">
        <el-col :span="1"></el-col>
        <el-col :span="15" :style="{color: vipType==0?'#5d5d5d':'#FE8F1B'}">
          <div>当前为{{VERSIONS[vipType]?VERSIONS[vipType].versionName:''}}</div>
          <div>{{endTimeStr}}</div>
        </el-col>
        <el-col :span="8">
          <a :href="buyVipUrl" target="_blank">
            <el-button type="warning"
                       :class="'button-warning'+vipType">
              去升级
            </el-button>
          </a>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-between" align="middle"
              style="height:80px;">
        <el-col :span="1"></el-col>
        <el-col :span="15">
          剩余下载额度：{{MG(residualDownloadTraffic)}}
        </el-col>
        <el-col :span="8">
          <el-button type="warning" @click="buyTraffic"
                     class="button-warning0">
            去提升
          </el-button>
        </el-col>
      </el-row>
      <el-row type="flex" justify="end" align="middle"
              style="height:60px;">
        <el-button type="text" @click="logout" style="padding-right: 20px;color:#5d5d5d;">
          退出
        </el-button>
      </el-row>
    </div>
  </el-popover>
</template>

<script>
  import App from '../../util/comfun'
  import ElButton from "../../../node_modules/element-ui/packages/button/src/button.vue";
  export default {
    components: {ElButton},
    props:{
      userinfo:{
        type:Object,
        value:null
      },
    },
    data () {
      return {
        vipType:0,
        endTimeStr:'永久有效',
        residualDownloadTraffic:0,
        buyVipUrl:'',
        VERSIONS:{},
      }
    },
    methods:{
      MG:App.MG,
      init(){
        let userId=wxlite.getStorageSync('userId')
        this.buyVipUrl=App.getH5({
          version:encodeURIComponent(JSON.stringify({
            from:'pc',
            token:wxlite.getStorageSync('token'),
            uid:userId})),
          "_":'',
        },'')
        App.demand('/user/vipInfo/current','GET').then(res=>{
          if(res.data){
            if(res.data.vipType>0){
              this.endTimeStr=App.unixtoTime(res.data.endTime,'有效期至YYYY年MM月DD日')
            }
            this.vipType=res.data.vipType
          }
        })
        App.demand('/user/info','GET',{
          userId:userId,
        }).then(res=>{
          this.residualDownloadTraffic=res.data.residualDownloadTraffic/1
        })
      },
      logout(){
        localStorage.removeItem('userinfo');
        this.$router.replace({
          path:'/'
        })
      },
      gotoService(){
        this.$router.replace({
          path:'/pay'
        })
      },
      buyVip(){
        this.$router.push({
          path:'/checkout/buyVip'
        })

      },
      buyTraffic(){
        let userId=wxlite.getStorageSync('userId')
        this.$router.push({
          path:'/checkout/buyTraffic?activityId=0&activityName=0&userId='+userId
        })
      },
      async getVersion(){
        if(!wxlite.VERSIONS){
          let vds=(await App.demand('/activity/version/loadConfigList','GET')).data;
          let vers={};
          vds.forEach(ver=>{
            vers[ver.versionType]=ver
          });
          wxlite.VERSIONS=vers
        }
        this.VERSIONS=wxlite.VERSIONS
      },
    },
    mounted(){
      this.getVersion()
      this.init();
    }
  }
</script>

<style>
  .fotoo-el-popover,.fotoo-el-popover.el-popover{
    padding: 0;
  }
  .header-img{
    position: relative;
    cursor: pointer;
    width: 35px;
    height: 35px;
  }
  .fotoo-el-popover-avatar {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    overflow: hidden;
  }
  .userName{
    height: 25px;
    font-size: 18px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    color: #5d5d5d;
    line-height: 25px;
  }
  .vip-icon{
      width: 18px;
      height: 17px;
      background-size: 100% 100%;
      background-image: url("https://assets.pfotoo.com/images/vip-0.png");
      position: absolute;
      bottom: -5px;
      right: -5px;
  }
  .vip-icon-0{
      background-image: url("https://assets.pfotoo.com/images/version/0.png");
  }
  .vip-icon-1{
      background-image: url("https://assets.pfotoo.com/images/version/1.png");
  }
  .vip-icon-11{
      background-image: url("https://assets.pfotoo.com/images/version/11.png");
  }
  .vip-icon-12{
      background-image: url("https://assets.pfotoo.com/images/version/12.png");
  }
  .vip-icon-21{
      background-image: url("https://assets.pfotoo.com/images/version/21.png");
  }
  .vip-icon-22{
      background-image: url("https://assets.pfotoo.com/images/version/22.png");
  }
  .reference .vip-icon{
    /*width: 18px;*/
    height: 18px;
    background-size: 14px 14px;
    background-image: url("https://assets.pfotoo.com/images/vip-0.png");
    background-position: 5px center;
    position: absolute;
    bottom: -10px;
    left: -20px;
    background-repeat: no-repeat;
    border-radius: 10px;
    text-indent: 20px;
    min-width: 75px;
    background-color: #FCCD01;

    font-weight: 600;
    font-size: 10px;
    color: #FFFFFF;
    line-height: 18px;
    padding-right: 5px;
    box-sizing: content-box;
    white-space: nowrap;
  }
  .reference .vip-icon-0{
    background-image: url("https://assets.pfotoo.com/images/version/icon-lite-0.png");
    background-color: #B8B6B6;
  }
  .reference .vip-icon-1{
    background-image: url("https://assets.pfotoo.com/images/version/icon-lite-1.png");
  }
  .reference .vip-icon-11{
    background-image: url("https://assets.pfotoo.com/images/version/icon-lite-11.png");
  }
  .reference .vip-icon-12{
    background-image: url("https://assets.pfotoo.com/images/version/icon-lite-12.png");
  }
  .reference .vip-icon-21{
    background-image: url("https://assets.pfotoo.com/images/version/icon-lite-21.png");
  }
  .reference .vip-icon-22{
    background-image: url("https://assets.pfotoo.com/images/version/icon-lite-22.png");
  }
  .el-button.button-warning0{
    width: 90px;
    height: 35px;
    border: 0px solid #fe8f1b;
    border-radius: 5px;

    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    color: #FFFFFF;
    background: linear-gradient(149deg,#fe8f1b 0%, #ffc370 93%);
    line-height: 10px;
    padding: 0;
  }
  .el-button.button-warning1{
    width: 90px;
    height: 35px;
    border: 1px solid #fe8f1b;
    border-radius: 5px;

    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    color: #fe8f1b;
    background: transparent;
    line-height: 10px;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/memberAvatar.vue